import { CalendarGrid_default } from "../Calendar/CalendarGrid.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DatePicker/DatePickerGrid.vue?vue&type=script&setup=true&lang.ts
var DatePickerGrid_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DatePickerGrid",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(CalendarGrid_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DatePicker/DatePickerGrid.vue
var DatePickerGrid_default = DatePickerGrid_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DatePickerGrid_default };
//# sourceMappingURL=DatePickerGrid.js.map